
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import TextFloating from "@/components/input/TextFloating.vue";
import FileInput from "@/components/input/FileInput.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import utils from "@/utils";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import ResourceModel from "@/models/createTicket/ResourceModel";
import ActivityViewModel from "@/models/createTicket/ActivityViewModel";
import WorkorderModel from "@/models/createTicket/WorkorderModel";
import dayjs from "dayjs";
@Component({
    components: {
        SubHeader,
        Search,
        MenuFooter,
        FileInput,

        ValidationObserver,
        ValidationProvider,
        TextFloating,
    },
})
export default class ListNotification extends Vue {
    mounted() {
        this.getDetailTicket(this.$route.params.id);
    }
    dayjs = dayjs;
    utils = utils;
    titlePage = "Assessment Report";
    date = "21/JAN/2022";
    time = "12.30";
    title = "Cake Engine Breaking Down";
    subTitle = "Lorem Ipsum is simply text";
    status = "new";
    isOpen = "0";
    ticket1: WorkorderModel = new WorkorderModel();
    isActiveDesc = false;

    step = 0;

    history = [];

    resource: ActivityViewModel = new ActivityViewModel();
    note = null;

    getImage(path) {
        return process.env.VUE_APP_SALUTARIA_API_URL + "/" + path;
    }
    getDetailTicket(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getActivity(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.resource = response.data.data;
                        // this.getDetailWorkorder(this.resource?.workorder?.id);
                        // resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    getDetailWorkorder(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getDetailTask2(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.ticket1 = Object.assign({}, response.data.data);
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    // get colorStatus() {
    //     if (this.resource?.status === "new") {
    //         return "cl-red";
    //     } else {
    //         return "cl-green-light";
    //     }
    // }
    // get pitaStatus() {
    //     if (this.resource?.status === "new") {
    //         return "new";
    //     } else {
    //         return "on-progress";
    //     }
    // }
}
